import { LeafletContext } from 'page/map-context.js';
import { useContext, useEffect, useRef } from 'react';
import {
  CONST_EMPTY_ARRAY,
  PW_MAP_BUTTON_ADDITIONAL,
  PW_MAP_BUTTON_RESET,
  PW_MAP_BUTTON_ZOOM_IN,
  PW_MAP_BUTTON_ZOOM_OUT,
} from 'utilities/consts/variable-types.js';
import { StickyLayoutPrimarySlots } from 'utilities/sticky/stickySlots.js';
import { MapButton, MapButtonProps } from './map-control-buttons.js';

export interface IZoomActions {
  zoomIn: () => void;
  zoomOut: () => void;
  reset?: () => void;
}

export interface IZoomControlProps {
  preventZoom?: boolean;
  addButtons?: Pick<MapButtonProps, 'onClick' | 'iconName' | 'title' | 'classes'>[];
  stickyOffset?: number;
  isSticky?: boolean;
  hasReset?: boolean;
  children?: React.ReactNode;
}

export const MapControlUI = ({
  preventZoom,
  addButtons = CONST_EMPTY_ARRAY,
  isSticky = false,
  stickyOffset,
  children,
  zoomIn,
  zoomOut,
  reset,
}: IZoomControlProps & IZoomActions) => {
  const mapFactory = useContext(LeafletContext);
  const MapFactoryRef = useRef(mapFactory);

  useEffect(() => {
    MapFactoryRef.current = mapFactory;
  }, [mapFactory]);

  return (
    <StickyLayoutPrimarySlots isSticky={isSticky} offset={stickyOffset} classes="u-pointerShow">
      <>
        {!preventZoom && (
          <div className="map-controls--btn-group border-radius-xs map-control-shade">
            <MapButton
              onClick={zoomIn}
              iconName="zoom-in"
              variant="top"
              testId={PW_MAP_BUTTON_ZOOM_IN}
              title="Zoom in"
              tooltipPlacement="left"
            />
            <MapButton
              onClick={zoomOut}
              iconName="zoom-out"
              variant={reset ? 'center' : 'bottom'}
              testId={PW_MAP_BUTTON_ZOOM_OUT}
              title="Zoom out"
              tooltipPlacement="left"
            />
            {reset && (
              <MapButton
                key={'default-view'}
                onClick={reset}
                iconName={'default-view'}
                variant="bottom"
                testId={PW_MAP_BUTTON_RESET}
                title="Reset view"
              />
            )}
          </div>
        )}
        {/* map buttons have classes of margin top so when there are no zoom buttons we need to adjust the margin */}
        <div className="map-controls--btn-group" style={{ marginTop: !preventZoom ? '0px' : '-0.5rem' }}>
          {addButtons.map((a, idx) => (
            <MapButton
              key={a.iconName}
              onClick={a.onClick}
              iconName={a.iconName}
              variant="isolated"
              classes={`map-control-shade u-mT-xs ${a.classes}`}
              testId={`${PW_MAP_BUTTON_ADDITIONAL}-${idx}`}
              title={a.title}
            />
          ))}
          {children}
        </div>
      </>
    </StickyLayoutPrimarySlots>
  );
};
